<template lang="pug">
  .video-content.container(v-if="!englishVersion && !mexicoVersion")
      .video-content__title(v-html="tr.video.title")
      .video-content__subtitle(v-html="tr.video.subtitle")
      .video
          <iframe width="100%" height="561px" src="https://www.youtube.com/embed/1tHLCiqzRJY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</template>

<script>
import langOps from '@/mixins/langOps'
export default {
  data () {
    return {
      section: 'main'
    }
  },
  mixin: [langOps]
}
</script>

<style lang="scss">
  .video-content {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    align-items: center;

    @media (max-width: 1024px) {
      margin-top: 0;
      display: block;
    }

    &__title {
      grid-column: 1/-1;
      margin-bottom: 34px;

      text-align: center;
      font-size: $fz_l;
      letter-spacing: 0.3px;

      @media (max-width: 1024px) {
        text-align: left;
      }
    }

    &__subtitle {
      grid-column: 1/-1;
      margin-bottom: 69px;

      text-align: center;
      font-size: $fz_s;
      line-height: 1.3;
      letter-spacing: 0.2px;

      @media (max-width: 1024px) {
        text-align: left;
      }
    }

    @media (max-width: 1024px) {
      align-items: flex-start;
    }
  }

  .video {
    grid-column: 2/-2;
    display: flex;
    justify-content: center;
    align-items: center;

    // @media (max-width: 1024px) {
    //   grid-column: 1/-1;
    // }

    min-height: 489px;
    border-radius: 6px;
    border: solid 1px #dcdcdc;
    background-color: transparent;

    @media (max-width: 1024px) {
      display: block;
      height: auto;
      min-height: 0;
    }

    iframe{
      margin-bottom: -5px;
      @media (max-width: 1024px) {
        display: block;
        height: auto;
        min-height: 0;
        height: auto;
      }
    }

    &__img {
      width: 72px;
      height: 50px;
    }
  }
</style>
